var map = {
	"./blitzdrop.png": 162,
	"./dani.png": 340,
	"./dondesiempre.png": 217,
	"./gameoflife.png": 73,
	"./portfolio.png": 152,
	"./seveneat.png": 561,
	"./vrp.png": 540,
	"./weaver.png": 670
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 120;